<template>
  <div class="container">
    <div class="col-xs-12">
      <router-link class="pull-right" to="/clientes">Volver a la lista</router-link>
    </div>
    <ul class="nav nav-tabs">
      <li role="presentation" class="active">
        <a href="#general" aria-controls="entradas" role="tab" data-toggle="tab">Datos generales</a>
      </li>
      <li role="presentation" v-show="guardadoBD">
        <a href="#sucursales" aria-controls="sucursales" role="tab" data-toggle="tab">Sucursales</a>
      </li>
      <li role="presentation" v-show="guardadoBD">
        <a href="#form-sucursal" aria-controls="sucursales" role="tab" data-toggle="tab">Form sucursal</a>
      </li>
      <li role="presentation" v-show="guardadoBD">
        <a href="#form-usuario" aria-controls="usuario" role="tab" data-toggle="tab">Nuevo usuario</a>
      </li>
      <li role="presentation" v-show="guardadoBD">
        <a href="#lista-usuarios" aria-controls="lista usuarios" role="tab" data-toggle="tab">Usuarios admin</a>
      </li>
    </ul>
    <div class="box-style line-top">
      <div class="tab-content">
        <div class="tab-pane active in fade" role="tabpanel" id="general">
          <form class="form smart-form">
            <div class="box-body">
              <div class="row">
                <div class="col-xs-12">
                  <div class="form-group">
                    <label for="">Razón Social</label>
                    <div class="input">
                      <input type="text" class="form-control" v-model="cliente.razonSocial">
                    </div>
                  </div>
                  <!--
                  <div class="form-group">
                    <label for="">Situacion IVA</label>
                    <select name="" id="" class="form-control"></select>
                  </div>
                  -->
                  <div class="text-center center-block">
                    <button class="btn btn-fill" @click.prevent="onGuardarCliente">Guardar Cliente</button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="tab-pane fade" role="tabpanel" id="sucursales" v-if="guardadoBD">
          <div class="form smart-form">
            <div class="box-body">
              <div class="row">
                <div class="pull-right">
                  <button class="btn btn-fill" @click.prevent="clickCrearSucursal">Crear sucursal</button>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Denominación</th>
                        <th>Dirección</th>
                        <th>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="sucursal in sucursales" v-if="sucursales.length > 0">
                        <td>{{sucursal.denominacion}}</td>
                        <td>{{sucursal.direccion.direccion}}</td>
                        <td>
                          <ul class="table-actions smart-form">
                            <li>
                              <a @click="setSucursalActiva(sucursal._id)" class="btn btn-xs btn-ghost" type="button">
                                <i class="fa fa-actions fa-edit"></i>
                              </a>
                              <a @click="setSucursalEdicion(sucursal)" class="btn btn-xs btn-ghost" type="button">
                                <i class="fa fa-actions fa-user"></i>
                              </a>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            </div>
        </div>
        <div class="tab-pane" id="form-sucursal" v-show="guardadoBD">
          <div class="form smart-form">
            <div class="box-body">
              <div class="row">
                <div class="col-xs-12 text-right">
                  <span class="label label-info" v-if="editandoSucursalGuardada">Editando sucursal {{sucursal.denominacion}}</span>
                  <span class="label label-info" v-else>Nueva sucursal</span>
                </div>
                <div class="col-xs-12">
                  <div class="form-group">
                    <label for="">Denominación</label>
                    <input type="text" class="form-control" v-model="sucursal.denominacion">
                  </div>
                  <div class="form-group">
                    <label for="">Dirección</label>
                    <vue-google-autocomplete
                      v-if="mapsLoaded"
                      id="map"
                      ref="direccion"
                      country="ar"
                      classname="form-control"
                      placeholder="Escriba la dirección"
                      v-on:placechanged="getAddressData">
                  </vue-google-autocomplete>
                  </div>
                  <div class="row">
                    <div class="col-xs-12 col-sm-4">
                      <div class="form-group">
                        <label for="">Torre</label>
                        <input type="text" v-model="direccion.torre" class="form-control">
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-4">
                      <label for="">Piso</label>
                      <input type="text" v-model="direccion.piso" class="form-control">
                    </div>
                    <div class="col-xs-12 col-sm-4">
                      <label for="">Departamento</label>
                      <input type="text" v-model="direccion.departamento" class="form-control">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-12 col-md-6">
                      <div class="form-group">
                        <label for="">LIMITE DE DÍAS PARA REALIZACIÓN DE PEDIDOS</label>
                        <input type="number" min="0" max="7" v-model="sucursal.daysToCancel" class="form-control text-right">
                      </div>
                      </div>
                      <div class="col-xs-12 col-md-6">
                        <div class="form-group">
                          <label for="">HORA LÍMITE PARA REALIZACIÓN DE PEDIDOS</label>
                          <br/>
                          <vue-timepicker v-model="sucursal.hoursToCancel" hide-clear-button></vue-timepicker>
                        </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-xs-12 col-sm-6 col-md-4">
                      <div class="form-group">
                        <label for="">Proveedores</label>
                        <select name="" id="" @change="onChangeProveedor" v-model="asignacion.proveedorActivo" class="form-control">
                          <option>Seleccione un proveedor</option>
                          <option :value="proveedor._id" v-for="proveedor in proveedores" :key="proveedor._id">{{proveedor.razonSocial}}</option>
                        </select>
                        <span class="label label-danger" v-if="!$v.asignacion.proveedorActivo.required && mostrarErroresProveedor">Debe seleccionar un proveedor</span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-4">
                      <div class="form-group">
                        <label for="">Combos del proveedor</label>
                        <select name="" id="" class="form-control" v-model="asignacion.comboSeleccionado" v-if="proveedorSeleccionado">
                          <option>Seleccione un combo</option>
                          <option :value="precio.combo._id" v-for="precio in proveedorSeleccionado.precios">{{precio.combo.nombre}}</option>
                        </select>
                        <span class="label label-danger" v-if="!$v.asignacion.comboSeleccionado.required && mostrarErroresProveedor">Debe seleccionar un combo</span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-4">
                      <div class="form-group">
                        <label for="">Horarios de entrega del Proveedor</label>
                        <select class="form-control" v-model="asignacion.horarioSeleccionado" v-if="proveedorSeleccionado">
                          <option value="">Seleccione un horario</option>
                          <option :value="horario" v-for="horario in proveedorSeleccionado.horariosEntrega">{{horario}}</option>
                        </select>
                        <span class="label label-danger" v-if="!$v.asignacion.horarioSeleccionado.required && mostrarErroresProveedor">Debe seleccionar un horario</span>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-12 col-sm-2">
                      <div class="form-group">
                        <label for="">Lunes</label>
                        <div class="input-group">
                          <input type="number" min="0" max="100" v-model="sucursal.subsidio.lunes" class="form-control text-right">
                          <span class="input-group-btn">
                            <button class="btn btn-default" @click.prevent="copiarATodos(sucursal.subsidio.lunes)"><i class="fa fa-copy"></i></button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-2">
                      <div class="form-group">
                        <label for="">Martes</label>
                        <div class="input-group">
                          <input type="number" min="0" max="100" v-model="sucursal.subsidio.martes" class="form-control text-right">
                          <span class="input-group-btn">
                            <button class="btn btn-default" @click.prevent="copiarATodos(sucursal.subsidio.martes)"><i class="fa fa-copy"></i></button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-2">
                      <div class="form-group">
                        <label for="">Miércoles</label>
                        <div class="input-group">
                          <input type="number" min="0" max="100" v-model="sucursal.subsidio.miércoles" class="form-control text-right">
                          <span class="input-group-btn">
                            <button class="btn btn-default" @click.prevent="copiarATodos(sucursal.subsidio.miércoles)"><i class="fa fa-copy"></i></button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-2">
                      <div class="form-group">
                        <label for="">Jueves</label>
                        <div class="input-group">
                          <input type="number" min="0" max="100" v-model="sucursal.subsidio.jueves" class="form-control text-right">
                          <span class="input-group-btn">
                            <button class="btn btn-default" @click.prevent="copiarATodos(sucursal.subsidio.jueves)"><i class="fa fa-copy"></i></button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-2">
                      <div class="form-group">
                        <label for="">Viernes</label>
                        <div class="input-group">
                          <input type="number" min="0" max="100" v-model="sucursal.subsidio.viernes" class="form-control text-right">
                          <span class="input-group-btn">
                            <button class="btn btn-default" @click.prevent="copiarATodos(sucursal.subsidio.viernes)"><i class="fa fa-copy"></i></button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-2">
                      <div class="form-group">
                        <label for="">Sábado</label>
                        <div class="input-group">
                          <input type="number" min="0" max="100" v-model="sucursal.subsidio.sábado" class="form-control text-right">
                          <span class="input-group-btn">
                            <button class="btn btn-default" @click.prevent="copiarATodos(sucursal.subsidio.sábado)"><i class="fa fa-copy"></i></button>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-12">
                      <button class="btn btn-fill" @click.prevent="agregarProveedor">
                        <span v-if="idxSucursalEditada < 0">Agregar proveedor asignado</span>
                        <span v-else>Guardar proveedor asignado</span>
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Proveedor</th>
                          <th>Combo</th>
                          <th>Horario</th>
                          <th>Subsidio</th>
                          <th>Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="asociado, idx in sucursal.proveedores">
                          <td>{{idAProveedor(asociado.proveedor)}}</td>
                          <td>{{idComboATexto(asociado.combo, asociado.proveedor)}}</td>
                          <td>{{asociado.horarioAsignado}}</td>
                          <td>{{asociado.subsidio | subsidioATexto}}</td>
                          <td>
                            <ul class="table-actions smart-form">
                              <li>
                                <a @click.prevent="onClickModificar(asociado, idx)" class="btn btn-xs btn-ghost" type="button">
                                  <i class="fa fa-actions fa-edit"></i>
                                </a>
                              </li>
                              <li>
                                <a @click.prevent="onClickEliminarProveedor(idx)" class="btn btn-xs btn-ghost" type="button">
                                  <i class="fa fa-actions fa-remove"></i>
                                </a>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="row">
                    <div class="text-center center-block">
                      <button class="btn btn-outline" @click.prevent="onClickGuardarSucursal">Guardar sucursal</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane" id="form-usuario" v-show="guardadoBD">
          <div class="row">
            <div class="box-style line-top">
							<div class="form smart-form" v-if="idSucursalEdicion">
							
								<!-- Agregar usuarios -->
								<div class="box-header">
									<h2>NUEVO USUARIO PARA {{nombreSucursalEdicion}}</h2>
								</div>
								<div class="box-body">
									<div class="row">
										<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
											<div class="form-group">
												<label>Nombre</label>
												<input type="text" name="" v-model="usuario.firstName" class="form-control">
                        <span class="label label-danger" v-if="(!$v.usuario.firstName.minLength || !$v.usuario.firstName.required) && mostrarErroresUsuario">El nombre no puede estar vacío</span> 
											</div>
										</div>
										<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
											<div class="form-group">
												<label>Apellido</label>
												<input type="text" v-model="usuario.lastName" class="form-control">
                        <span class="label label-danger" v-if="(!$v.usuario.lastName.minLength || !$v.usuario.lastName.required) && mostrarErroresUsuario">El apellido no puede estar vacío</span> 
											</div>
										</div>
										<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
											<div class="form-group">
												<label>E-mail</label>
												<input type="mail" v-model="usuario.email" class="form-control">
                        <span class="label label-danger" v-if="(!$v.usuario.email.required || !$v.usuario.email.email) && mostrarErroresUsuario">Email no válido</span> 
											</div>
										</div>
										<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
											<div class="form-group">
												<label>Celular</label>
												<input type="text" v-model="usuario.telefonoCelular" class="form-control">
											</div>
										</div>
										<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
											<div class="row">
												<div class="col-xs-12 col-sm-6 col-md-8 col-lg-8">
													<div class="form-group">
														<label>Teléfono fijo</label>
														<input type="text" v-model="usuario.telefonoFijo" class="form-control" placeholder="De su área de trabajo">
													</div>
												</div>
												<div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
													<div class="form-group">
														<label>Interno</label>
														<input type="text" v-model="usuario.interno" class="form-control">
													</div>
												</div>
											</div>
										</div>
										<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
											<div class="form-group">
												<label>Área</label>
												<div class="select" v-model="usuario.area">
													<select>
														<option value="">Elija...</option>
														<option value="">Atención al Cliente</option>
														<option value="">Administración</option>
														<option value="">Contaduría</option>
														<option value="">Área comercial</option>
														<option value="">Recepción</option>
													</select>
													<i class="fa fa fa-angle-down"></i>
												</div>
											</div>
										</div>
									</div>
								</div><!-- fin Datos personales -->

								<div class="box-header subline-top">
									<h2>DATOS DE ACCESO</h2>
								</div>
								<div class="box-body">
									<div class="row">
										<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
											<div class="form-group">
												<label>Usuario</label>
												<input type="text" v-model="usuario.username" class="form-control">
                        <span class="label label-danger" v-if="(!$v.usuario.username.minLength || !$v.usuario.username.required) && mostrarErroresUsuario">El nombre de usuario es requerido y como mínimo debe tener 3 caracteres</span> 
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
											<div class="form-group">
												<label>Contraseña</label>
												<input type="password" v-model="usuario.password" class="form-control">
                        <span class="label label-danger" v-if="(!$v.usuario.password.minLength || !$v.usuario.password.required) && mostrarErroresUsuario">El password es requerido y como mínimo debe tener 6 caracteres</span> 
											</div>
										</div>
										<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
											<div class="form-group">
												<label>Repetir contraseña</label>
												<input type="password" v-model="usuario.repeat" class="form-control">
                        <span class="label label-danger" v-if="!$v.usuario.repeat.sameAsPassword && mostrarErroresUsuario">No coincide con la contraseña</span> 
											</div>
										</div>
									</div>
									<div class="form-action text-center">
                    <ul class="list-unstyled danger" v-if="errors.length > 0" v-for="error in errors">
                      <li><span class="label label-danger">{{error}}</span></li>
                    </ul>
										<button @click.prevent="clickGuardarUsuario" class="btn btn-fill">GUARDAR</button>
									</div>
								</div>
							</div>
              <div v-else>
                <h1 class="text-center">Debe seleccionar una sucursal de la pestaña Sucursales</h1>
              </div>
						</div>
          </div>
        </div>
        <div class="tab-pane" id="lista-usuarios" v-show="guardadoBD">
          <div class="row">
            <table class="table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Email</th>
                  <th>Pertenece a</th>
                  <th>Sucursales Administradas</th>
                  <th>Activo</th1>
                  <th class="derecha">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="usuario in usuarios">
                  <td>{{usuario.displayName}}</td>
                  <td>{{usuario.email}}</td>
                  <td>{{usuario.sucursalAsociada.denominacion}}</td>
                  <td v-if="usuario.sucursalesAdministradas.length>0">
                    <span v-if="usuario.sucursalesAdministradas.length==1">
                      {{usuario.sucursalesAdministradas[0].denominacion}}
                    </span>
                    <span v-else>
                      {{usuario.sucursalesAdministradas.length}}
                    </span>                    
                    <a class="btn btn-xs btn-ghost pull-right" type="button" title="Cambiar sucursales administradas" @click="onClickCambiarSucursalesAdministradas(usuario)">
                      <i class="fa fa-actions fa-tags"></i>
                    </a>
                  </td>
                  <td v-else>
                    {{usuario.sucursalAsociada.denominacion}} 
                    <a class="btn btn-xs btn-ghost pull-right" type="button" title="Cambiar sucursales administradas" @click="onClickCambiarSucursalesAdministradas(usuario)">
                      <i class="fa fa-actions fa-tags"></i>
                    </a>
                  </td>
                  <td>
                    <i v-if="usuario.activado" class="fa fa-check"></i>
                    <i v-else class="fa fa-times"></i>
                  </td>
                  <td>
                      <ul class="table-actions smart-form">
                        <li v-if="usuario.activado">
                          <a class="btn btn-xs btn-ghost" type="button" title="Desactivar" @click="onClickCambiarActivo(usuario._id, false)">
                            <i class="fa fa-actions fa-user-times"></i>
                          </a>
                        </li>
                        <li v-else>
                          <a class="btn btn-xs btn-ghost" type="button" title="Activar" @click="onClickCambiarActivo(usuario._id, true)">
                            <i class="fa fa-actions fa-user-plus"></i>
                          </a>
                        </li>
                      </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  
    <div class="modal" v-if="usuarioActivo" ref="modalAdministrarSucursal" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">{{usuarioActivo.displayName}}</h4>
          </div>
            <div class="modal-body">
              <div class="smart-form">
                <div class="form-group">
                  <h4 for="">Sucursales Administradas</h4>
                </div>
                <div class="form-group" v-for="suc in sucursales">
                    <span v-if="suc._id==usuarioActivo.sucursalAsociada._id" class="fa fa-building"></span> 
                    <span v-else>
                      <a @click="toggleSucursal(suc)">
                        <i class="fa fa-check-square-o" v-if="sucursalSeleccionada(suc)"></i>
                        <i class="fa fa-square-o" v-else></i>
                      </a>
                    </span>
                    {{suc.denominacion}}
                </div>
                <div class="form-group">
                  <div class="text-center center-block">
                    <button class="btn btn-fill" @click="guardarSucursalesAdministradas()">Guardar</button>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>

  </div>

</template>
<script>
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import {minLength, required, email, sameAs} from 'vuelidate/lib/validators'
import 'sweetalert2/dist/sweetalert2.css'
import swal from 'sweetalert2'
import $ from 'jquery'
import { findIndex, cloneDeep, map } from 'lodash'
import VueTimepicker from 'vue2-timepicker'

export default {
  components: {
    'vue-google-autocomplete': VueGoogleAutocomplete,
    'vue-timepicker': VueTimepicker
  },
  props: ['maps-loaded'],
  filters: {
    subsidioATexto (value) {
      return `L:${value.lunes}%, M:${value.martes}%, X:${value.miércoles}%, J:${value.jueves}%, V:${value.viernes}%, S:${value.sábado}%`
    },
    limiteCancelacion (value) {
      return `Dias:${value.daysToCancel}, Hora:${value.cancelHours}`
    }
  },
  data () {
    return {
      usuarioActivo: undefined,
      errors: [],
      guardadoBD: false,
      idSucursalEdicion: false,
      nombreSucursalEdicion: '',
      mostrarErroresUsuario: true,
      cliente: {
        _id: null,
        razonSocial: ''
      },
      sucursal: {
        _id: null,
        denominacion: '',
        proveedoresAsociados: [],
        proveedores: [],
        subsidio: {
          comboAsignado: null,
          lunes: 0,
          martes: 0,
          miércoles: 0,
          jueves: 0,
          viernes: 0,
          sábado: 0,
          domingo: 0
        }

      },
      asignacion: {
        comboSeleccionado: null,
        horarioSeleccionado: null,
        daysToCancel: null,
        cancelHours: null,
        proveedorActivo: null
      },
      direccion: {
        direccion: '',
        direccionFormateada: '',
        latitud: 0,
        longitud: 0,
        torre: '',
        piso: '',
        departamento: ''
      },
      usuario: {
        firstName: '',
        lastName: '',
        email: '',
        area: '',
        username: '',
        password: '',
        repeat: '',
        telefonoFijo: '',
        telefonoCelular: '',
        interno: ''
      },
      editandoSucursalGuardada: false,
      editandoProveedorSucursal: false,
      idxSucursalEditada: -1,
      mostrarErroresProveedor: false,
      proveedorSeleccionado: null,
      proveedores: [],
      sucursales: [],
      usuarios: []
    }
  },
  validations: {
    razonSocial: {
      required,
      minLength: minLength(3)
    },
    sucursal: {
      denominacion: {
        required,
        minLength: minLength(3)
      },
      direccion: {
        direccion: {
          required,
          minLength: minLength(3)
        }
      }
    },
    asignacion: {
      comboSeleccionado: {
        required
      },
      proveedorActivo: {
        required
      },
      horarioSeleccionado: {
        required
      }
    },
    usuario: {
      firstName: {
        required,
        minLength: minLength(2)
      },
      lastName: {
        required,
        minLength: minLength(2)
      },
      email: {
        required,
        email
      },
      username: {
        required,
        minLength: minLength(3)
      },
      password: {
        required,
        minLength: minLength(6)
      },
      repeat: {
        required,
        sameAsPassword: sameAs('password')
      }
    }

  },
  mounted () {
    const me = this
    me.$http.get('/api/admin/initformcliente/', {
      params: {
        idCliente: me.$route.params.id || null
      }
    }).then(({body}) => {
      me.cliente = body.cliente
      me.sucursales = body.sucursales
      me.proveedores = body.proveedores
      me.guardadoBD = body.guardadoBD
      me.usuarios = body.usuarios
    })
  },
  methods: {
    guardarSucursalesAdministradas () {
      const me = this
      me.$http.post('/api/admin/sucursalesAdministradas', {
        sucursales: map(me.usuarioActivo.sucursalesAdministradas, '_id'),
        id: me.usuarioActivo._id
      }).then(({body}) => {
        let usuarioCambiado = me.usuarios.find((usuario) => {
          return usuario._id === me.usuarioActivo._id
        })
        usuarioCambiado.sucursalesAdministradas = me.usuarioActivo.sucursalesAdministradas
        $(me.$refs.modalAdministrarSucursal).modal('hide')
      }, (err) => {
        console.error(err)
      })
    },
    toggleSucursal (sucursal) {
      const me = this
      let idx = findIndex(me.usuarioActivo.sucursalesAdministradas, {_id: sucursal._id})
      if (idx < 0) {
        me.usuarioActivo.sucursalesAdministradas.push(sucursal)
      } else {
        me.usuarioActivo.sucursalesAdministradas.splice(idx, 1)
      }
    },
    sucursalSeleccionada (sucursal) {
      const me = this
      return findIndex(me.usuarioActivo.sucursalesAdministradas, {_id: sucursal._id}) >= 0
    },
    onClickCambiarSucursalesAdministradas (usuario) {
      const me = this
      me.usuarioActivo = cloneDeep(usuario)
      if (me.usuarioActivo.sucursalesAdministradas.length === 0) {
        me.usuarioActivo.sucursalesAdministradas.push(me.usuarioActivo.sucursalAsociada)
      }
      $(me.$refs.modalAdministrarSucursal).modal()
    },
    cambiarEstadoActivo (id, valor) {
      const me = this
      me.$http.post('/api/admin/cambiarestadoactivo', {
        valor: valor,
        id: id
      }).then(({body}) => {
        let usuarioCambiado = me.usuarios.find((usuario) => {
          return usuario._id === id
        })
        usuarioCambiado.activado = valor
      }, (err) => {
        console.error(err)
      })
    },
    clearAsignacion () {
      const me = this
      me.idxSucursalEditada = -1
      me.proveedorSeleccionado = null
      me.asignacion = {
        comboSeleccionado: null,
        horarioSeleccionado: null,
        daysToCancel: null,
        cancelHours: null,
        proveedorActivo: null
      }
      me.sucursal.subsidio = {
        comboAsignado: null,
        lunes: 0,
        martes: 0,
        miércoles: 0,
        jueves: 0,
        viernes: 0,
        sábado: 0,
        domingo: 0
      }
    },
    clearSucursal () {
      const me = this
      me.sucursal = {
        _id: null,
        denominacion: '',
        proveedoresAsociados: [],
        proveedores: [],
        subsidio: {
          comboAsignado: null,
          lunes: 0,
          martes: 0,
          miércoles: 0,
          jueves: 0,
          viernes: 0,
          sábado: 0,
          domingo: 0
        }
      }
      me.idxSucursalEditada = -1
      me.clearDireccion()
      me.clearAsignacion()
    },
    clearDireccion () {
      const me = this
      me.direccion = {
        direccion: '',
        direccionFormateada: '',
        latitud: 0,
        longitud: 0,
        torre: '',
        piso: '',
        departamento: ''
      }
      me.$refs.direccion.clear()
    },
    clickCrearSucursal () {
      const me = this
      me.clearSucursal()
      $('.nav-tabs a[href="#form-sucursal"]').tab('show')
    },
    clickGuardarUsuario () {
      const me = this
      let data = me.usuario
      me.errors = []
      data.sucursalAsociada = me.idSucursalEdicion
      me.$http.post('/api/admin/crearusuariocliente', data).then(({body}) => {
        me.idSucursalEdicion = null
        me.nombreSucursalEdicion = ''
        me.$emit('mostrar-notificacion', 'El usuario fue creado correctamente', 'success')
        me.$router.push({
          path: '/clientes'
        })
      }, (err) => {
        me.errors = err.body
      })
    },
    copiarATodos (valorDia) {
      const me = this
      let val = valorDia
      Object.assign(me.sucursal.subsidio, {
        lunes: val,
        martes: val,
        miércoles: val,
        jueves: val,
        viernes: val,
        sábado: val
      })
    },
    getAddressData (e, place) {
      const me = this
      me.direccion = {
        latitud: e.latitude,
        longitud: e.longitude,
        direccion: place.name,
        direccionFormateada: place.formatted_address,
        torre: me.direccion.torre,
        piso: me.direccion.piso,
        departamento: me.direccion.departamento
      }
      console.log('direccion', me.direccion)
    },
    onChangeProveedor (e) {
      const me = this
      me.asignacion.comboSeleccionado = null
      me.asignacion.horarioSeleccionado = null
      me.asignacion.daysToCancel = 1
      me.asignacion.cancelHours = { HH: '16', mm: '00' }
      me.proveedorSeleccionado = me.proveedores.find((proveedor) => {
        return proveedor._id === e.target.value
      })
    },
    onClickCambiarActivo (id, valor) {
      const me = this
      swal({
        title: 'Confirme operación',
        text: '¿Desea cambiar el estado del usuario seleccionado?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si',
        cancelButtonText: 'No, dejar sin efecto'
      }).then(() => {
        me.cambiarEstadoActivo(id, valor)
      }, (dismiss) => {
        return false
      })
    },
    onClickEliminarProveedor (idx) {
      const me = this
      swal({
        title: 'Confirme operación',
        text: '¿Desea eliminar el proveedor asignado?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si',
        cancelButtonText: 'No, dejar sin efecto'
      }).then(() => {
        me.sucursal.proveedores.splice(idx, 1)
      }, (dismiss) => {
        return false
      })
    },
    onClickGuardarSucursal () {
      const me = this
      let sucursal = Object.assign({}, me.sucursal)
      sucursal.cancelHours = '' + me.sucursal.hoursToCancel.HH + ':' + me.sucursal.hoursToCancel.mm
      sucursal.direccion = Object.assign({}, me.direccion)
      sucursal.idEmpresaCliente = me.cliente._id
      me.$http.post('/api/admin/sucursales', sucursal).then(({body}) => {
        let sucursal = body
        let existeSucursal = me.sucursales.find((sucursalEnCliente) => {
          return sucursal._id === sucursalEnCliente._id
        })
        if (!existeSucursal) {
          me.sucursales.push(body)
        } else {
          Object.assign(existeSucursal, body)
        }
        me.editandoSucursalGuardada = false
        me.clearSucursal()
        $('.nav-tabs a[href="#sucursales"]').tab('show')
      }, (err) => {
        console.error(err)
      })
    },
    onClickModificar (asignacion, idx) {
      console.log('onClickModificar', asignacion, idx)
      const me = this
      me.asignacion.proveedorActivo = asignacion.proveedor
      me.proveedorSeleccionado = me.proveedores.find((proveedor) => {
        return proveedor._id === asignacion.proveedor
      })
      me.asignacion.comboSeleccionado = asignacion.combo
      me.asignacion.horarioSeleccionado = asignacion.horarioAsignado
      me.asignacion._id = asignacion._id
      me.sucursal.subsidio = asignacion.subsidio
      me.editandoProveedorSucursal = true
      me.idxSucursalEditada = idx
    },
    onGuardarCliente () {
      const me = this
      me.$http.post('/api/admin/clientes', me.cliente).then(({body}) => {
        me.$emit('mostrar-notificacion', 'El cliente se ha guardado', 'success')
        me.guardadoBD = true
      }, (err) => {
        console.error(err)
      })
    },
    idAProveedor (value) {
      const me = this
      let resultado = ''
      let proveedor = me.proveedores.find((proveedor) => {
        return proveedor._id === value
      })
      if (proveedor) {
        resultado = proveedor.razonSocial
      }
      return resultado
    },
    idComboATexto (idCombo, idProveedor) {
      const me = this
      let prov = me.proveedores.find((proveedor) => {
        return proveedor._id === idProveedor
      })
      let precio = prov.precios.find((precio) => {
        return precio.combo._id === idCombo
      })
      return precio.combo.nombre
    },
    setSucursalActiva (id) {
      const me = this
      me.sucursal = me.sucursales.find((sucursal) => {
        return sucursal._id === id
      })
      me.sucursal.hoursToCancel = { HH: me.sucursal.cancelHours.split(':')[0], mm: me.sucursal.cancelHours.split(':')[1] }
      me.direccion = me.sucursal.direccion
      me.$refs.direccion.update(me.direccion.direccionFormateada)
      me.editandoSucursalGuardada = true
      me.clearAsignacion()
      $('.nav-tabs a[href="#form-sucursal"]').tab('show')
    },
    setSucursalEdicion (sucursal) {
      const me = this
      me.idSucursalEdicion = sucursal._id
      me.nombreSucursalEdicion = sucursal.denominacion.toUpperCase()
      $('.nav-tabs a[href="#form-usuario"]').tab('show')
    },
    agregarProveedor () {
      const me = this
      me.mostrarErroresProveedor = false
      if (me.$v.asignacion.$invalid) {
        console.log('asignacion no valida')
        me.mostrarErroresProveedor = true
        return false
      }
      let existeProveedorCombo = me.sucursal.proveedores.find((item) => {
        return item.proveedor === me.asignacion.proveedorActivo && item.combo === me.asignacion.comboSeleccionado
      })
      if (existeProveedorCombo) {
        // me.$emit('mostrar-notificacion', 'Ya existe ese combo y proveedor', 'error')
        // return false
      }
      let subsidio = Object.assign({}, me.sucursal.subsidio)
      subsidio.comboAsignado = me.asignacion.comboSeleccionado
      let itemProveedor = {
        _id: me.asignacion._id,
        proveedor: me.asignacion.proveedorActivo,
        combo: me.asignacion.comboSeleccionado,
        horarioAsignado: me.asignacion.horarioSeleccionado,
        subsidio: subsidio
      }
      if (me.idxSucursalEditada > -1) {
        me.sucursal.proveedores.splice(me.idxSucursalEditada, 1)
        me.sucursal.proveedores.push(itemProveedor)
      } else {
        me.sucursal.proveedores.push(itemProveedor)
      }
      me.clearAsignacion()
    }
  }
}
</script>



// WEBPACK FOOTER //
// FormCliente.vue?558789f4